module.exports = __webpack_public_path__ + "1c08a4920c34981a6e1ed5c2a57a14ad.svg";